import { setShowValuationHistoryModal } from '../State/showValuationHistoryModal';

export default () => async (dispatch) => {
  dispatch(setShowValuationHistoryModal(false))
}